/* =========================================
   GIORDANO CANADA - FREE SHIPPING GOAL (v3)
   Minimog 4.0.0

   v3: "Free Standard Shipping" copy, $0 / threshold scale labels,
       (i) details tooltip (tap / click / Esc / outside click).
   ========================================= */

(function () {
  "use strict";

  /* Prevent a double init if the file is included twice. */
  if (window.__gcaShippingGoalLoaded) {
    return;
  }

  window.__gcaShippingGoalLoaded = true;


  var GOAL_SELECTOR = "[data-gca-shipping-goal]";
  var UNLOCKED_CLASS = "gca-shipping-goal--unlocked";
  var CELEBRATE_CLASS = "gca-shipping-goal--celebrate";
  var INFO_TOGGLE = "[data-gca-shipping-info-toggle]";
  var INFO_PANEL = "[data-gca-shipping-info-panel]";
  var INFO_OPEN_CLASS = "gca-shipping-goal--info-open";
  var OBSERVER_TARGETS = "[data-minimog-cart-items], [data-cart-subtotal]";

  /*
    Any request that changes the cart, from the theme OR
    from apps (upsells, bundles, free gift apps ...):
    /cart/add.js, /cart/change, /fr/cart/update.js?sections=...
  */
  var CART_MUTATION_URL = /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/;

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;

  var updateTimer = null;
  var flushTimer = null;
  var requestCounter = 0;
  var activeRequestController = null;
  var minimogConnected = false;
  var cartObserver = null;
  var observedTargets = [];

  /*
    Last known unlocked state across all goal
    instances (cart drawer + cart page).

    null  = no cart response received yet.
    The very first response only records the state,
    so a page that loads with free shipping already
    unlocked never celebrates.
  */
  var lastUnlocked = null;

  /*
    true = threshold was crossed but no goal was on
    screen (e.g. drawer still closed). The celebration
    plays as soon as the customer can actually see it.
  */
  var pendingCelebration = false;


  /* =========================================
     HELPERS
     ========================================= */

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return "/";
  }


  function getShippingGoals() {
    return Array.prototype.slice.call(document.querySelectorAll(GOAL_SELECTOR));
  }


  function clamp(number, min, max) {
    return Math.min(Math.max(number, min), max);
  }


  function reducedMotionEnabled() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }


  function stripHtml(value) {
    return String(value || "").replace(/<[^>]*>/g, "").trim();
  }


  function isGoalVisible(goal) {
    if (!goal || !goal.isConnected || goal.hidden) {
      return false;
    }

    if (typeof goal.checkVisibility === "function") {
      var visible = goal.checkVisibility({
        checkOpacity: true,
        checkVisibilityCSS: true
      });

      if (!visible) {
        return false;
      }
    }

    var rect = goal.getBoundingClientRect();

    if (!rect.width || !rect.height) {
      return false;
    }

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    /* A closed drawer is usually translated off-screen. */
    return (
      rect.right > 0 &&
      rect.left < viewportWidth &&
      rect.bottom > 0 &&
      rect.top < viewportHeight
    );
  }


  /* =========================================
     MONEY FORMATTING
     Uses the shop's own money format (passed
     from Liquid) so JS output matches Liquid's
     "| money" output. Falls back to Intl.
     ========================================= */

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var number = Number(cents) / 100;

    if (isNaN(number)) {
      number = 0;
    }

    var parts = number.toFixed(precision).split(".");

    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);

    var fraction = parts[1] ? decimal + parts[1] : "";

    return whole + fraction;
  }


  function formatWithPattern(cents, pattern) {
    pattern = stripHtml(pattern);

    if (!pattern) {
      return null;
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = placeholder.exec(pattern);

    if (!match) {
      return null;
    }

    var value;

    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2, ",", ".");
        break;

      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;

      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;

      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;

      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;

      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ".");
        break;

      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;

      case "amount_with_period_and_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;

      default:
        return null;
    }

    return pattern.replace(placeholder, function () {
      return value;
    });
  }


  function formatMoney(cents, currency, pattern) {
    var formatted = pattern ? formatWithPattern(cents, pattern) : null;

    if (formatted) {
      return formatted;
    }

    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-CA", {
        style: "currency",
        currency: currency || "CAD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return "$" + amount.toFixed(2);
    }
  }


  /* "$100.00" -> "$100" for the scale labels and tooltip (matches Liquid's money_without_trailing_zeros). */
  function formatMoneyShort(cents, currency, pattern) {
    return String(formatMoney(cents, currency, pattern)).replace(/([.,])00(?!\d)/, "");
  }


  /* =========================================
     THRESHOLD + CURRENCY
     data-threshold is in SHOP currency cents.
     If the customer browses in another currency
     (Shopify Markets), convert it with Shopify's
     live rate. If no rate is available, the goal
     stays hidden rather than showing a wrong number.
     ========================================= */

  function getGoalContext(goal, cart) {
    var baseThreshold = parseInt(goal.dataset.threshold, 10);

    if (!baseThreshold || baseThreshold <= 0) {
      return null;
    }

    var shopCurrency = goal.dataset.shopCurrency || "";
    var cartCurrency = cart.currency || shopCurrency || "CAD";

    if (!shopCurrency || cartCurrency === shopCurrency) {
      return {
        threshold: baseThreshold,
        currency: cartCurrency,
        pattern: goal.dataset.moneyFormat
      };
    }

    var rate =
      window.Shopify && window.Shopify.currency
        ? parseFloat(window.Shopify.currency.rate)
        : NaN;

    if (!rate || isNaN(rate) || rate <= 0) {
      return null;
    }

    return {
      threshold: Math.round(baseThreshold * rate),
      currency: cartCurrency,
      pattern: null /* shop pattern is for the shop currency, use Intl */
    };
  }


  /* =========================================
     SUCCESS CELEBRATION
     ========================================= */

  function removeExistingCelebration(goal) {
    if (!goal) {
      return;
    }

    goal.classList.remove(CELEBRATE_CLASS);

    goal.querySelectorAll(".gca-shipping-confetti").forEach(function (element) {
      element.remove();
    });
  }


  function createConfetti(goal) {
    if (!goal || reducedMotionEnabled()) {
      return;
    }

    var oldLayer = goal.querySelector(".gca-shipping-confetti");

    if (oldLayer) {
      oldLayer.remove();
    }

    var layer = document.createElement("div");

    layer.className = "gca-shipping-confetti";
    layer.setAttribute("aria-hidden", "true");

    /* Small, controlled number keeps the animation subtle and lightweight. */
    var pieceCount = 10;

    for (var i = 0; i < pieceCount; i++) {
      var piece = document.createElement("span");

      piece.className = "gca-shipping-confetti__piece";

      piece.style.left = 6 + Math.random() * 88 + "%";
      piece.style.setProperty("--gca-confetti-x", -18 + Math.random() * 36 + "px");
      piece.style.setProperty("--gca-confetti-rotate", 180 + Math.random() * 300 + "deg");
      piece.style.setProperty("--gca-confetti-delay", Math.random() * 150 + "ms");
      piece.style.setProperty("--gca-confetti-duration", 600 + Math.random() * 250 + "ms");

      layer.appendChild(piece);
    }

    goal.appendChild(layer);

    /* Max delay + max duration is about 1000ms. */
    window.setTimeout(function () {
      if (layer && layer.parentNode) {
        layer.remove();
      }
    }, 1200);
  }


  function celebrateFreeShipping(goal) {
    if (!goal || reducedMotionEnabled()) {
      return;
    }

    removeExistingCelebration(goal);

    /* Force reflow so the animation can replay on a later cross. */
    void goal.offsetWidth;

    goal.classList.add(CELEBRATE_CLASS);

    createConfetti(goal);

    window.setTimeout(function () {
      goal.classList.remove(CELEBRATE_CLASS);
    }, 900);
  }


  function flushPendingCelebration() {
    if (!pendingCelebration || lastUnlocked !== true) {
      return;
    }

    var visibleGoals = getShippingGoals().filter(function (goal) {
      return goal.classList.contains(UNLOCKED_CLASS) && isGoalVisible(goal);
    });

    if (!visibleGoals.length) {
      return; /* keep it pending until the drawer / page shows it */
    }

    pendingCelebration = false;

    visibleGoals.forEach(celebrateFreeShipping);
  }


  function scheduleFlush(delay) {
    clearTimeout(flushTimer);

    flushTimer = window.setTimeout(flushPendingCelebration, delay || 0);
  }


  /* =========================================
     MESSAGE
     Built with DOM nodes (no innerHTML) and
     only rewritten when the state changes, so
     screen readers (aria-live) do not repeat
     the same text and the MutationObserver is
     not triggered needlessly.
     ========================================= */

  function clearNode(node) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }


  function createStrong(text) {
    var strong = document.createElement("strong");

    strong.textContent = text;

    return strong;
  }


  function updateMessage(message, unlocked, remainingCents, remainingText) {
    if (!message) {
      return;
    }

    var key = unlocked ? "unlocked" : "locked:" + remainingCents;
    var currentKey = message.getAttribute("data-state");

    if (currentKey === key) {
      return;
    }

    /* Still locked, only the amount changed: update just the number. */
    if (!unlocked && currentKey && currentKey.indexOf("locked:") === 0) {
      var amountElement = message.querySelector("[data-gca-shipping-remaining]");

      if (amountElement) {
        amountElement.textContent = remainingText;
        message.setAttribute("data-state", key);

        return;
      }
    }

    clearNode(message);

    if (unlocked) {
      var check = document.createElement("span");

      check.className = "gca-shipping-goal__check";
      check.setAttribute("aria-hidden", "true");
      check.textContent = "\u2713";

      message.appendChild(check);
      message.appendChild(document.createTextNode(" You\u2019ve unlocked "));
      message.appendChild(createStrong("Free Standard Shipping"));
    } else {
      var amountStrong = createStrong(remainingText);

      amountStrong.setAttribute("data-gca-shipping-remaining", "");

      message.appendChild(document.createTextNode("You\u2019re "));
      message.appendChild(amountStrong);
      message.appendChild(document.createTextNode(" away from "));
      message.appendChild(createStrong("Free Standard Shipping"));
    }

    message.setAttribute("data-state", key);
  }


  /* =========================================
     UPDATE ONE SHIPPING GOAL
     Returns the unlocked state, or null if
     this goal could not be rendered.
     ========================================= */

  function renderGoal(goal, cart) {
    var context = getGoalContext(goal, cart);

    if (!context) {
      goal.hidden = true;

      return null;
    }

    var threshold = context.threshold;
    var cartTotal = Number(cart.total_price || 0);

    if (isNaN(cartTotal) || cartTotal < 0) {
      cartTotal = 0;
    }

    var unlocked = cartTotal >= threshold;

    /*
      Whole basis points (0-10000), same maths as
      the Liquid snippet. Floor means a locked cart
      can never show a full (100%) bar.
    */
    var basisPoints = clamp(Math.floor((cartTotal * 10000) / threshold), 0, 10000);
    var progress = basisPoints / 100;
    var progressFloor = Math.floor(basisPoints / 100);

    var remaining = Math.max(threshold - cartTotal, 0);

    goal.hidden = false;

    goal.dataset.cartTotal = String(cartTotal);
    goal.dataset.progress = String(progress);

    goal.style.setProperty("--gca-shipping-progress", progress + "%");

    /* Accessibility */

    var progressElement = goal.querySelector("[data-gca-shipping-progress]");

    if (progressElement) {
      progressElement.setAttribute("aria-valuenow", String(progressFloor));
      progressElement.setAttribute(
        "aria-valuetext",
        unlocked
          ? "Free standard shipping unlocked"
          : progressFloor + "% toward free standard shipping"
      );
    }

    /* Message */

    updateMessage(
      goal.querySelector("[data-gca-shipping-message]"),
      unlocked,
      remaining,
      formatMoney(remaining, context.currency, context.pattern)
    );

    /* Scale labels + tooltip amount (only differ from Liquid when a converted currency is shown) */

    updateLabels(goal, threshold, context);

    /* State class */

    if (unlocked) {
      goal.classList.add(UNLOCKED_CLASS);
    } else {
      goal.classList.remove(UNLOCKED_CLASS);
      removeExistingCelebration(goal);
    }

    return unlocked;
  }


  function setTextIfChanged(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }


  function updateLabels(goal, threshold, context) {
    var maxText = formatMoneyShort(threshold, context.currency, context.pattern);

    setTextIfChanged(
      goal.querySelector("[data-gca-shipping-scale-min]"),
      formatMoneyShort(0, context.currency, context.pattern)
    );
    setTextIfChanged(goal.querySelector("[data-gca-shipping-scale-max]"), maxText);
    setTextIfChanged(goal.querySelector("[data-gca-shipping-tip-amount]"), maxText);
  }


  function resetGoal(goal) {
    closeInfo(goal);

    goal.hidden = true;

    goal.classList.remove(UNLOCKED_CLASS);

    removeExistingCelebration(goal);

    goal.style.setProperty("--gca-shipping-progress", "0%");

    goal.dataset.cartTotal = "0";
    goal.dataset.progress = "0";
  }


  /* =========================================
     UPDATE ALL SHIPPING GOALS
     ========================================= */

  function renderShippingGoals(cart) {
    if (!cart) {
      return;
    }

    var goals = getShippingGoals();

    /* Empty cart */

    if (!cart.item_count || cart.item_count <= 0) {
      goals.forEach(resetGoal);

      lastUnlocked = false;
      pendingCelebration = false;

      return;
    }

    if (!goals.length) {
      return;
    }

    var unlocked = null;

    goals.forEach(function (goal) {
      var result = renderGoal(goal, cart);

      if (result !== null) {
        unlocked = result;
      }
    });

    if (unlocked === null) {
      return;
    }

    /* Celebrate ONLY on a move from locked to unlocked. */
    if (unlocked && lastUnlocked === false) {
      pendingCelebration = true;
    }

    if (!unlocked) {
      pendingCelebration = false;
    }

    lastUnlocked = unlocked;

    if (pendingCelebration) {
      /* Small delay lets an opening drawer settle first. */
      scheduleFlush(250);
    }
  }


  /* =========================================
     FETCH LATEST SHOPIFY CART
     ========================================= */

  function refreshShippingGoal() {
    /* Minimog may have re-rendered the drawer: re-attach the observer if needed. */
    startCartObserver();

    if (!getShippingGoals().length || !nativeFetch) {
      return;
    }

    if (activeRequestController) {
      activeRequestController.abort();
    }

    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var requestId = ++requestCounter;

    activeRequestController = controller;

    nativeFetch(getRootUrl() + "cart.js", {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Unable to load cart.");
        }

        return response.json();
      })
      .then(function (cart) {
        /* Ignore stale responses (older browsers without AbortController). */
        if (requestId !== requestCounter) {
          return;
        }

        renderShippingGoals(cart);
      })
      .catch(function (error) {
        if (error && error.name === "AbortError") {
          return;
        }

        console.warn("Giordano shipping goal:", error);
      })
      .finally(function () {
        if (activeRequestController === controller) {
          activeRequestController = null;
        }
      });
  }


  /* =========================================
     DEBOUNCED REFRESH
     ========================================= */

  function scheduleShippingGoalUpdate(delay) {
    clearTimeout(updateTimer);

    updateTimer = window.setTimeout(
      refreshShippingGoal,
      typeof delay === "number" ? delay : 100
    );
  }


  /* =========================================
     NETWORK HOOKS
     Catches every cart change, including ones
     made by apps that never fire Minimog events.
     ========================================= */

  function isCartMutationUrl(url) {
    return Boolean(url) && CART_MUTATION_URL.test(String(url));
  }


  function getRequestUrl(input) {
    if (typeof input === "string") {
      return input;
    }

    if (input && typeof input.url === "string") {
      return input.url; /* Request object */
    }

    if (input && typeof input.href === "string") {
      return input.href; /* URL object */
    }

    return "";
  }


  function patchNetwork() {
    if (window.fetch && !window.fetch.__gcaPatched) {
      var originalFetch = window.fetch;

      var patchedFetch = function (input) {
        var promise = originalFetch.apply(window, arguments);

        if (isCartMutationUrl(getRequestUrl(input))) {
          promise.then(
            function (response) {
              if (response && response.ok) {
                scheduleShippingGoalUpdate(120);
              }
            },
            function () {}
          );
        }

        return promise;
      };

      patchedFetch.__gcaPatched = true;
      window.fetch = patchedFetch;
    }

    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__gcaPatched) {
      var proto = XMLHttpRequest.prototype;
      var originalOpen = proto.open;
      var originalSend = proto.send;

      proto.open = function (method, url) {
        this.__gcaCartMutation = isCartMutationUrl(url);

        return originalOpen.apply(this, arguments);
      };

      proto.send = function () {
        if (this.__gcaCartMutation) {
          this.addEventListener("load", function () {
            if (this.status >= 200 && this.status < 300) {
              scheduleShippingGoalUpdate(120);
            }
          });
        }

        return originalSend.apply(this, arguments);
      };

      proto.__gcaPatched = true;
    }
  }


  /* =========================================
     MINIMOG CART EVENTS
     ========================================= */

  function connectMinimogEvents() {
    if (minimogConnected) {
      return true;
    }

    if (
      !window.MinimogEvents ||
      !window.MinimogTheme ||
      !window.MinimogTheme.pubSubEvents ||
      typeof window.MinimogEvents.subscribe !== "function"
    ) {
      return false;
    }

    var events = window.MinimogTheme.pubSubEvents;

    if (events.cartUpdate) {
      window.MinimogEvents.subscribe(events.cartUpdate, function () {
        scheduleShippingGoalUpdate(80);
      });
    }

    if (events.openCartDrawer) {
      window.MinimogEvents.subscribe(events.openCartDrawer, function () {
        closeAllInfo(null);
        scheduleShippingGoalUpdate(50);

        /* Play a waiting celebration once the drawer has slid in. */
        scheduleFlush(450);
      });
    }

    minimogConnected = true;

    return true;
  }


  /* =========================================
     CART DOM OBSERVER
     Re-attaches itself when Minimog replaces
     the cart markup (section re-render), so it
     never ends up watching detached nodes.
     ========================================= */

  function handleCartMutations(mutations) {
    /* Ignore our own changes inside the goal, otherwise we would loop. */
    var external = mutations.some(function (mutation) {
      var node =
        mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;

      return !(node && node.closest(GOAL_SELECTOR));
    });

    if (external) {
      scheduleShippingGoalUpdate(120);
    }
  }


  function startCartObserver() {
    if (typeof MutationObserver === "undefined") {
      return true;
    }

    var targets = Array.prototype.slice.call(document.querySelectorAll(OBSERVER_TARGETS));

    if (!targets.length) {
      return false;
    }

    var unchanged =
      cartObserver &&
      targets.length === observedTargets.length &&
      targets.every(function (target, index) {
        return observedTargets[index] === target;
      });

    if (unchanged) {
      return true;
    }

    if (cartObserver) {
      cartObserver.disconnect();
    }

    cartObserver = new MutationObserver(handleCartMutations);

    targets.forEach(function (target) {
      cartObserver.observe(target, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });

    observedTargets = targets;

    return true;
  }


  /* =========================================
     INTEGRATIONS (with safety retry)
     ========================================= */

  function connectIntegrations() {
    var eventsReady = connectMinimogEvents();
    var observerReady = startCartObserver();

    return eventsReady && observerReady;
  }


  function ensureIntegrations() {
    if (connectIntegrations()) {
      return;
    }

    /* Safety retry in case theme-global or the drawer initializes later. */
    var attempts = 0;

    var retry = window.setInterval(function () {
      attempts += 1;

      if (connectIntegrations() || attempts >= 10) {
        window.clearInterval(retry);
      }
    }, 300);
  }


  /* =========================================
     (i) DETAILS TOOLTIP
     Touch: tap toggles. Desktop: hover (CSS) or
     click to pin. Esc / outside click closes.
     The panel lives in the drawer header, which
     Minimog never re-renders, so listeners on
     document are enough.
     ========================================= */

  function closeInfo(goal) {
    if (!goal) {
      return;
    }

    var toggle = goal.querySelector(INFO_TOGGLE);
    var panel = goal.querySelector(INFO_PANEL);

    goal.classList.remove(INFO_OPEN_CLASS);

    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
    }

    if (panel) {
      panel.hidden = true;
    }
  }


  function closeAllInfo(except) {
    getShippingGoals().forEach(function (goal) {
      if (goal !== except) {
        closeInfo(goal);
      }
    });
  }


  function openInfo(goal) {
    var toggle = goal.querySelector(INFO_TOGGLE);
    var panel = goal.querySelector(INFO_PANEL);

    if (!toggle || !panel) {
      return;
    }

    closeAllInfo(goal);

    goal.classList.add(INFO_OPEN_CLASS);
    toggle.setAttribute("aria-expanded", "true");
    panel.hidden = false;
  }


  document.addEventListener("click", function (event) {
    var target = event.target;

    if (!target || typeof target.closest !== "function") {
      return;
    }

    var toggle = target.closest(INFO_TOGGLE);

    if (toggle) {
      var goal = toggle.closest(GOAL_SELECTOR);

      if (!goal) {
        return;
      }

      event.preventDefault();

      if (toggle.getAttribute("aria-expanded") === "true") {
        closeInfo(goal);
      } else {
        openInfo(goal);
      }

      return;
    }

    /* Taps inside the open panel keep it open; anything else closes it. */
    if (!target.closest(INFO_PANEL)) {
      closeAllInfo(null);
    }
  });


  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" && event.key !== "Esc") {
      return;
    }

    var openGoal = document.querySelector(GOAL_SELECTOR + "." + INFO_OPEN_CLASS);

    if (!openGoal) {
      return;
    }

    closeInfo(openGoal);

    var toggle = openGoal.querySelector(INFO_TOGGLE);

    if (toggle && typeof toggle.focus === "function") {
      toggle.focus();
    }
  });


  /* =========================================
     CART DRAWER OPEN (fallback for the event)
     Remove / quantity clicks are no longer
     needed: the network hooks catch them.
     ========================================= */

  document.addEventListener("click", function (event) {
    var target = event.target;

    if (!target || typeof target.closest !== "function") {
      return;
    }

    if (target.closest(".m-cart-icon-bubble")) {
      scheduleShippingGoalUpdate(150);
      scheduleFlush(500);
    }
  });


  /* =========================================
     PAGE RETURN / BROWSER CACHE SAFETY
     ========================================= */

  window.addEventListener("pageshow", function (event) {
    /* Only when restored from back/forward cache; normal loads use init. */
    if (event.persisted) {
      scheduleShippingGoalUpdate(100);
    }
  });


  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      scheduleShippingGoalUpdate(150);
    }
  });


  /* =========================================
     PUBLIC API (apps, debugging)
     window.GCAShippingGoal.refresh()
     ========================================= */

  window.GCAShippingGoal = {
    refresh: function () {
      scheduleShippingGoalUpdate(0);
    },
    render: renderShippingGoals
  };


  /* =========================================
     INITIALIZE
     ========================================= */

  function initShippingGoal() {
    patchNetwork();

    /* Verify the initial Liquid state against Shopify's latest cart JSON. */
    scheduleShippingGoalUpdate(60);

    ensureIntegrations();
  }


  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShippingGoal);
  } else {
    initShippingGoal();
  }
})();
